import { FileText, Search, Shield, AlertTriangle, BarChart3, ChevronRight } from 'lucide-react';

const steps = [
  { icon: FileText, title: 'Ingestion', desc: 'Deliverables parsed & indexed' },
  { icon: Search, title: 'Document AI', desc: 'Structure & content understood' },
  { icon: Shield, title: 'Compliance Engine', desc: 'Deterministic + AI checks' },
  { icon: AlertTriangle, title: 'Findings', desc: 'Evidence-linked & triaged' },
  { icon: BarChart3, title: 'Dashboards', desc: 'Traceable, audit-ready' },
];

/** Simplified horizontal pipeline graphic (first-pass reproduction). */
const WorkflowGraphic = () => (
  <div className="vr-flow">
    {steps.map((s, i) => (
      <div key={s.title} style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
        <div className="vr-flow-step">
          <div className="vr-flow-node">
            <s.icon size={20} />
          </div>
          <h4>{s.title}</h4>
          <p>{s.desc}</p>
        </div>
        {i < steps.length - 1 && (
          <div className="vr-flow-arrow">
            <ChevronRight size={18} />
          </div>
        )}
      </div>
    ))}
  </div>
);

export default WorkflowGraphic;
